import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import Select from 'react-select'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { objNameRoles } from '../../../../../const/constRoles'
import { fnArraySelectStatus } from '../../../../../const/constStatuses_waterTruckRequest'
import {
  priorityOptions,
  typeDeliveryOptions,
} from '../WaterTruckRequestNewAndEdit'
import { GET_ALL_PROVIDERS } from '../../../../../graphql/Catalog/Providers/providers'

const nameColumnDateTypeOptions = [
  {
    value: 'createdAt',
    label: 'Fecha creacion',
  },
  {
    value: 'completed_at',
    label: 'Fecha completado',
  },
]

const stylesSelect = {
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
}

const allStatus = fnArraySelectStatus()

const ModalFilters = ({
  user,
  setPagePagination,
  pagePagination,
  setIsFiltered,
  isFiltered,
}) => {
  const isRoleProvider =
    user.role === objNameRoles.provedor_pipas ? true : false

  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')
  const [statusId, setStatusId] = useState(null)
  const [volume, setVolume] = useState(null)
  const [priority, setPriority] = useState(null)
  const [typeDelivery, setTypeDelivery] = useState(null)
  const [nameColumnDateType, setNameColumnDateType] = useState(
    nameColumnDateTypeOptions[0]
  )
  const [arraySelectStatus, setArraySelectStatus] = useState([])
  const [providersOptions, setProvidersOptions] = useState([])
  const [providerId, setProviderId] = useState(null)

  const {
    loading: loadingProviders,
    error: errorProviders,
    data: dataProviders,
  } = useQuery(GET_ALL_PROVIDERS, {
    variables: {},
    skip: isRoleProvider,
  })

  const handleChangeSelectTypesDates = (selected) => {
    setPagePagination((old) => ({
      ...old,
      filters: {
        ...old.filters,
        nameColumnDateType: selected?.value ? selected.value : null,
      },
    }))
    return setNameColumnDateType(selected?.value ? selected : null)
  }

  const handleChangeFilterDateRange = ({ dateValue, type }) => {
    const nameProp = type === 'from' ? 'dateFrom' : 'dateTo'
    const value = dateValue ? dateValue : null
    setPagePagination((old) => ({
      ...old,
      filters: {
        ...old.filters,
        nameColumnDateType: nameColumnDateType.value,
        [nameProp]: value,
      },
    }))
    if (nameProp === 'dateFrom') setDateFrom(value ?? '')
    else if (nameProp === 'dateTo') setDateTo(value ?? '')
  }

  const handleChangeStatus = (selected) => {
    setPagePagination((old) => ({
      ...old,
      filters: {
        ...old.filters,
        status_id: selected?.value ? parseInt(selected.value) : null,
      },
    }))
    return setStatusId(selected?.value ? selected : null)
  }

  const handleChangeVolume = (selected) => {
    setPagePagination((old) => ({
      ...old,
      filters: {
        ...old.filters,
        volume: selected?.value ? selected.value : null,
      },
    }))
    return setVolume(selected?.value ? selected : null)
  }

  const handleChangePriority = (selected) => {
    setPagePagination((old) => ({
      ...old,
      filters: {
        ...old.filters,
        priority: selected?.value ? selected.value : null,
      },
    }))
    return setPriority(selected?.value ? selected : null)
  }

  const handleChangeTypeDelivery = (selected) => {
    setPagePagination((old) => ({
      ...old,
      filters: {
        ...old.filters,
        type_delivery: selected?.value ? selected.value : null,
      },
    }))
    return setTypeDelivery(selected?.value ? selected : null)
  }

  const handleChangeProvider = (selected) => {
    setPagePagination((old) => ({
      ...old,
      filters: {
        ...old.filters,
        provider_id: selected?.value ? selected.value : null,
      },
    }))
    return setProviderId(selected?.value ? selected : null)
  }

  const handleCleanFilters = () => {
    setNameColumnDateType(nameColumnDateTypeOptions[0])
    setDateFrom('')
    setDateTo('')
    setStatusId(null)
    setVolume(null)
    setPriority(null)
    setTypeDelivery(null)
    setProviderId(null)

    return setPagePagination((old) => ({
      ...old,
      filters: {
        status_id: null,
        nameColumnDateType: null,
        dateFrom: null,
        dateTo: null,
        volume: null,
        priority: null,
        type_delivery: null,
        provider_id: null,
      },
    }))
  }

  useEffect(() => {
    if (user.role) {
      return setArraySelectStatus(allStatus)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.role])

  useEffect(() => {
    if (pagePagination.filters) {
      const {
        status_id,
        nameColumnDateType,
        dateFrom,
        dateTo,
        volume,
        priority,
        type_delivery,
        provider_id,
      } = pagePagination.filters

      if (status_id || volume || priority || type_delivery || provider_id)
        return setIsFiltered(true)
      if (nameColumnDateType && dateFrom && !dateTo) return setIsFiltered(true)
      if (nameColumnDateType && dateFrom && dateTo) return setIsFiltered(true)
      setIsFiltered(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagePagination.filters])

  useEffect(() => {
    if (isRoleProvider) return
    try {
      if (loadingProviders) return
      if (errorProviders) throw errorProviders
      let list = []
      dataProviders.getAllProviders.rows.map((provider) => {
        return list.push({
          value: provider.id,
          label: `${provider.card_name} - ${provider.rfc}`,
        })
      })
      setProvidersOptions(list)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataProviders, errorProviders, loadingProviders])

  return (
    <>
      <div className="row col-12 d-flex flex-wrap mb-3 gap-4">
        <div className="pl-0 mr-3 mb-3">
          <Label id="typesDate" text="Campo de fecha" icon={false} />
          <Select
            id="typesDate"
            name="typesDate"
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={stylesSelect}
            placeholder={'Selecciona uno'}
            noOptionsMessage={() => 'No hay opciones'}
            options={nameColumnDateTypeOptions}
            onChange={(selected) =>
              handleChangeSelectTypesDates(selected ?? null)
            }
            value={nameColumnDateType}
          />
        </div>

        <div className="mr-3 mb-3">
          <Label id="dateFrom" text={'Fecha inicio'} />
          <input
            id="dateFrom"
            name="dateFrom"
            type="date"
            className="input-field form-control position-searchInput"
            onChange={(e) => {
              handleChangeFilterDateRange({
                dateValue: e.target.value,
                type: 'from',
              })
            }}
            value={dateFrom}
          />
        </div>

        <div className="mr-3 mb-3">
          <Label id="dateTo" text={'Fecha fin'} />
          <input
            id="dateTo"
            name="dateTo"
            type="date"
            className="input-field form-control position-searchInput"
            onChange={(e) =>
              handleChangeFilterDateRange({
                dateValue: e.target.value,
                to: 'to',
              })
            }
            value={dateTo}
          />
        </div>

        <div className="pl-0 mr-3 mb-3">
          <Label id="statusId" text="Status" icon={false} />
          <Select
            id={'statusId'}
            name={'statusId'}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={stylesSelect}
            placeholder={'Selecciona un status'}
            noOptionsMessage={() => 'No hay opciones'}
            options={arraySelectStatus}
            onChange={(selected) => handleChangeStatus(selected ?? null)}
            isClearable={true}
            value={statusId}
          />
        </div>

        <div className="pl-0 mr-3 mb-3">
          <Label id="volume" text="Volumen" icon={false} />
          {/* <Select
            id={'volume'}
            name={'volume'}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={stylesSelect}
            placeholder={'Selecciona'}
            noOptionsMessage={() => 'No hay opciones'}
            options={volumeOptions}
            onChange={(selected) => handleChangeVolume(selected ?? null)}
            isClearable={true}
            value={volume}
          /> */}
        </div>

        <div className="pl-0 mr-3 mb-3">
          <Label id="priority" text="Prioridad" icon={false} />
          <Select
            id={'priority'}
            name={'priority'}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={stylesSelect}
            placeholder={'Selecciona'}
            noOptionsMessage={() => 'No hay opciones'}
            options={priorityOptions}
            onChange={(selected) => handleChangePriority(selected ?? null)}
            isClearable={true}
            value={priority}
          />
        </div>

        <div className="pl-0 mr-3 mb-3">
          <Label id="typeDelivery" text="Tipo de entrega" icon={false} />
          <Select
            id={'typeDelivery'}
            name={'typeDelivery'}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={stylesSelect}
            placeholder={'Selecciona'}
            noOptionsMessage={() => 'No hay opciones'}
            options={typeDeliveryOptions}
            onChange={(selected) => handleChangeTypeDelivery(selected ?? null)}
            isClearable={true}
            value={typeDelivery}
          />
        </div>

        {!isRoleProvider && (
          <div className="pl-0 mr-3 mb-3">
            <Label id="providerId" text="Proveedor" icon={false} />
            <Select
              id={'providerId'}
              name={'providerId'}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={stylesSelect}
              placeholder={'Selecciona'}
              noOptionsMessage={() => 'No hay opciones'}
              options={providersOptions}
              onChange={(selected) => handleChangeProvider(selected ?? null)}
              isClearable={true}
              value={providerId}
            />
          </div>
        )}
      </div>

      {isFiltered && (
        <div className="float-right">
          <button
            className="btn btn-sm btn-purple"
            onClick={() => handleCleanFilters()}
          >
            Limpiar filtros
          </button>
        </div>
      )}
    </>
  )
}

const Label = ({ id, text, icon = true }) => {
  return (
    <span htmlFor={id} style={{ fontSize: 14 }}>
      <b>
        {icon && (
          <i className="far fa-calendar-alt mr-1" style={{ fontSize: 11 }} />
        )}
        {text}
      </b>
    </span>
  )
}

export default ModalFilters
